<template>
  <nav
    class="navbar navbar-expand-lg navbar-expand-md navbar-dark bg-primary header-row"
  >
    <div class="container-fluid">
      <div class="col-2 py-2 align-content-center">
     
        <div
          class="llp-logo-dashboard px-3"
          @click="service"
          role="button"
          style="cursor: pointer"
        >
          <img
            :alt="logoAlt"
            :aria-label="logoAlt"
            src="/images/makbilllogo.png"
            class="header-logo"
          />
        </div>
      </div>

      <!-- Hamburger Menu -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="fas fa-bars"></i>
      </button>

      <!-- Collapsible Navbar Content -->
      <div
        class="collapse navbar-collapse header-mobile"
        id="navbarSupportedContent"
      >
        <ul
          class="navbar-nav me-5 mb-2 mb-lg-0 d-flex justify-content-end ms-auto"
        >
          <!-- User Management Dropdown -->
          <li
            class="nav-item dropdown maak-bill-header"
            v-if="userRoles.length"
          >
            <a
              class="nav-link dropdown-toggle text-white"
              href="#"
              id="userManagementDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              User Management
            </a>
            <ul class="dropdown-menu" aria-labelledby="userManagementDropdown">
              <li v-for="(role, index) in userRoles" :key="index">
                <router-link
                  class="dropdown-item"
                  to="#"
                  @click.prevent="navigateToRole(role)"
                  :class="{ 'active fw-bold': isActive(role) }"
                >
                  {{ role.name }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Settings Dropdown -->
          <li
            class="nav-item dropdown maak-bill-header ms-lg-2 ms-md-3"
            v-if="isAdminOrSuperAdmin"
          >
            <a
              class="nav-link dropdown-toggle text-white"
              href="#"
              id="settingsDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Settings
            </a>
            <ul class="dropdown-menu" aria-labelledby="settingsDropdown">
              <!-- <li v-for="(role, index) in charges" :key="index"> -->
              <li v-for="(role, index) in filteredCharges" :key="index">
                <router-link
                  class="dropdown-item"
                  to="#"
                  @click.prevent="navigateToRole(role)"
                  :class="{ 'active fw-bold': isActive(role) }"
                >
                  {{ role.name }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Reports -->
          <li class="nav-item maak-bill-header ms-lg-2 ms-md-3">
            <router-link class="nav-link text-white" to="/user-reports">
              Reports
            </router-link>
          </li>

          <!-- Wallet -->
          <ul
            class="navbar-nav me-auto mb-2 ms-lg-2 mb-lg-0 ms-md-3 wallet-nav-item" v-if="this.userRole !== '4'"
          >
            <li class="nav-item m-lg-2 m-md-2 wallet">Wallet: {{Wallet}}</li>
          </ul>
        </ul>

        <!-- User Profile -->
        <form class="d-flex me-3 user-profile-form">
          <img v-if="userProfilePic" alt="Picture" class="profile-pic" />
          <i v-else class="fas fa-user-circle profile-pic"></i>
          <ul
            id="side-navbar"
            class="navbar-nav me-auto mb-2 mb-lg-0 mt-0 ms-auto"
          >
            <li class="nav-item dropdown header-profile">
              <a
                id="navbarDropdown"
                class="nav-link dropdown-toggle text-white text-nowrap text-capitalize login-username"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
              >
                {{ userName }}
              </a>
              <ul
                class="dropdown-menu dropdown-menu-end"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <router-link to="/user-profile" class="dropdown-item"
                    >Manage Profile</router-link
                  >
                </li>
                <li>
                  <router-link to="/user-support" class="dropdown-item"
                    >Help</router-link
                  >
                </li>
                <li>
                  <a class="dropdown-item" @click="doLogout">Sign Out</a>
                </li>
              </ul>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </nav>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import ErrorService from "../../services/error.service";
import NetworkService from "../../services/network.service.js";

export default {
  name: "TheHeader",
  data() {
    return {
      login_user_role_id: localStorage.getItem("role_id"),
      logoAlt: "Company Logo",
      userRoles: [],
      userRoleId: localStorage.getItem("User_id"),
      userRole: localStorage.getItem("role_id"),
      userName:localStorage.getItem("userName"),
      Wallet:localStorage.getItem("wallet") || 0.00,
      allRoles: {
        1: [
          { name: "Admin", link: "/admin" },
          { name: "Distributor", link: "/distributor" },
          { name: "Retailer", link: "/retailer" },
        ],
        2: [
          { name: "Distributor", link: "/distributor" },
          { name: "Retailer", link: "/retailer" },
        ],
        3: [{ name: "Retailer", link: "/retailer" }],
      },
      charges: [
        { name: "Charges", link: "/charges" },
        { name: "Commissions", link: "/commissions" },
        { name: "Customer Charges", link: "/customer-charges" },
        { name: "Payment Configuration", link: "/payment-configuration" },
        { name: "Service Payment Configuration", link: "/service-payment-configuration" },
      ],
    };
  },
  computed: {
    isAdminOrSuperAdmin() {
      return this.userRole == "1" || this.userRole == "2";
    },
    filteredCharges() {
      if (this.userRole === "1") {
        return this.charges;
      } else {
        return this.charges.filter(
          (charge) => charge.name !== "Payment Configuration" && charge.name !== "Customer Charges" && charge.name !== "Service Payment Configuration"
        );
      }
    },
  },
  created() {
    const roleId = this.login_user_role_id;
    this.userRoles = this.allRoles[roleId] || [];
  },
  methods: {
    service() {
      
      if (this.userRole == "4") {
        this.$router.push("/services");
      }
    },

    doLogout() {
      localStorage.removeItem("authToken");
      localStorage.removeItem("Ref_id");
      localStorage.removeItem("User_id");
      localStorage.removeItem("role_id");
      localStorage.removeItem("userName")
      localStorage.removeItem("wallet")

      NetworkService.post("/logout")
        .catch((error) => {
        if (this.$refs.toast) {
  this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
} else {
   this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
}

        })
        .finally(() => {
          this.$router.push("/");
        });
    },
    navigateToRole(role) {
      if (role.name === "Charges") {
        this.$router.push("/charges");
      } else if (role.name === "Commissions") {
        this.$router.push("/commissions");
      } else if (role.name === "Payment Configuration") {
        this.$router.push("/payment-configuration");
      }else if (role.name === "Customer Charges") {
        this.$router.push("/customer-charges");
      }else if(role.name === "Service Payment Configuration")
      {
        this.$router.push("/service-payment-configuration")
      }
      
      else {
        this.$router.push(`/user-details/${role.name.toLowerCase()}`);
      }
    },
    // isActive(role) {
    //   return this.$route.path === role.link;
    // },
    isActive(role) {
      const userManagementRoleNames = ["Admin", "Distributor", "Retailer"];
      if (userManagementRoleNames.includes(role.name)) {
        const expectedPath = `/user-details/${role.name.toLowerCase()}`;
        return this.$route.path === expectedPath;
      }
  return this.$route.path === role.link;
},
  },
};
</script>
